<template lang="pug">
.position_field.mb-3
  .position_field_svg_wrapper(ref="positionfield")
  .labels.mt-sm-1.mt-sm-2.mt-md-5
    p 兩分球
    .mark_group
      .mark
        .rect.bg_white.border
        span < 30%
      .mark
        .rect(:style="{ background: subColor }")
        span 30% ~ 50%
      .mark
        .rect(:style="{ background: mainColor }")
        span > 50%
  .labels.mt-2
    p 三分球
    .mark_group
      .mark
        .rect.bg_white.border
        span < 20%
      .mark
        .rect(:style="{ background: subColor }")
        span 20% ~ 33%
      .mark
        .rect(:style="{ background: mainColor }")
        span > 33%
</template>

<script>
export default {
  name: "PositionField",
  props: {
    positionList: Array,
    mainColor: String,
    subColor: String,
  },
  watch: {
    positionList() {
      this.setScore();
      this.addEventListener();
    },
  },
  data() {
    return {
      colorWhite: "#FAFAFA",
      blockColor: {},
      svgFlag: 0,
      svgCode:
        '<?xml version="1.0" encoding="UTF-8"?> <svg class="position_field_svg" width="569px" height="372px" viewBox="0 0 569 372" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="position_field_svg" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="position" transform="translate(0.000000, 0.000000)"><rect id="PAINT" position="PAINT" fill="#202D3D" fill-rule="nonzero" x="203.797128" y="1.079208" width="165.147029" height="205"></rect><path d="M202.797128,209.631965 L369.655525,209.631965 L368.944157,269.435717 C342.827616,279.620191 316.088713,289.631965 287.509853,289.631965 C258.930993,289.631965 231.274425,278.88046 202.792899,269.827331 L202.797128,209.631965 Z" id="TOP_OF_THE_ARC_2_PTS" position="TOP_OF_THE_ARC_2_PTS" fill="#2185FF" fill-rule="nonzero"></path><path d="M203.652812,269.827331 C231.526107,282.437548 256.869897,289.631965 284.942801,289.631965 C313.015706,289.631965 339.21187,282.437548 368.681414,269.827331 L371.933945,370.960396 L199.800585,370.048535 L203.652812,269.827331 Z" id="TOP_OF_THE_ARC_3_PTS" position="TOP_OF_THE_ARC_3_PTS" fill="#5AFF4E" fill-rule="nonzero"></path><rect id="RIGHT_BASELINE_2_PTS" position="RIGHT_BASELINE_2_PTS" fill="#226FCD" fill-rule="nonzero" x="367.088474" y="2.07920792" width="103" height="110"></rect><path d="M370.848126,113.361386 L470.39645,114.272277 L470.39645,269.435717 C456.247959,269.435717 436.802759,252.875388 414.244576,224.871287 C391.686392,196.867187 403.947355,214.672468 399.544793,208.960396 C382.703717,187.110064 371.816568,161.5 371.816568,154.871287 C371.816568,148.884475 371.905185,144.082007 371.816568,137.854741 C371.753649,133.433339 371.430835,125.268887 370.848126,113.361386 Z" id="RIGHT_WING_2_PTS" position="RIGHT_WING_2_PTS" fill="#F3FF76" fill-rule="nonzero" transform="translate(420.622288, 191.398551) scale(-1, 1) translate(-420.622288, -191.398551) "></path><rect id="RIGHT_BASELINE_3_PTS" position="RIGHT_BASELINE_3_PTS" fill="#202D3D" fill-rule="nonzero" x="470.205965" y="2.07920792" width="96.679637" height="110"></rect><path d="M370.848126,115.252749 L470.726837,114.272277 L471.504794,161.5 C482.80058,181.784981 490.808783,195.451647 495.529403,202.5 C502.530014,212.952607 512.229907,222.966068 513.932802,224.871287 C524.599468,236.805281 543.31676,251.66009 570.084675,269.435717 L570.084675,371.079208 L370.848126,371.272277 L370.848126,115.252749 Z" id="RIGHT_WING_3_PTS" position="RIGHT_WING_3_PTS" stroke="#FFFFFF" fill="#E11B5F" fill-rule="nonzero" transform="translate(470.466401, 242.772277) scale(-1, 1) translate(-470.466401, -242.772277) "></path><rect id="LEFT_BASELINE_2_PTS" position="LEFT_BASELINE_2_PTS" fill="#226FCD" fill-rule="nonzero" transform="translate(152.588474, 59.079208) scale(-1, 1) translate(-152.588474, -59.079208) " x="102.088474" y="4.07920792" width="101" height="110"></rect><path d="M100.848126,114.361386 L200.39645,115.272277 L200.39645,270.435717 C186.247959,270.435717 166.802759,253.875388 144.244576,225.871287 C121.686392,197.867187 133.947355,215.672468 129.544793,209.960396 C112.703717,188.110064 101.816568,162.5 101.816568,155.871287 C101.816568,149.884475 101.905185,145.082007 101.816568,138.854741 C101.753649,134.433339 101.430835,126.268887 100.848126,114.361386 Z" id="LEFT_WING_2_PTS" position="LEFT_WING_2_PTS" fill="#F3FF76" fill-rule="nonzero"></path><rect id="LEFT_BASELINE_3_PTS" position="LEFT_BASELINE_3_PTS" fill="#202D3D" fill-rule="nonzero" transform="translate(52.045783, 59.079208) scale(-1, 1) translate(-52.045783, -59.079208) " x="2.20596455" y="4.07920792" width="99.679637" height="110"></rect><path d="M2.84812623,115.252749 L102.726837,114.272277 L103.504794,161.5 C114.80058,181.784981 122.808783,195.451647 127.529403,202.5 C134.530014,212.952607 144.229907,222.966068 145.932802,224.871287 C156.599468,236.805281 175.31676,251.66009 202.084675,269.435717 L202.084675,371.079208 L2.84812623,371.272277 L2.84812623,115.252749 Z" id="LEFT_WING_3_PTS" position="LEFT_WING_3_PTS" stroke="#FFFFFF" fill="#E11B5F" fill-rule="nonzero"></path><polygon id="Stroke-1" stroke="#eef0f5" stroke-width="4.5" points="0 371.079208 569.885602 371.079208 569.885602 2.07920792 0 2.07920792"></polygon><path d="M101.39645,159.871287 C135.074438,236.917834 205.041889,289.871287 285.89645,289.871287 C366.750336,289.871287 436.718461,236.917067 470.39645,159.871287" id="Stroke-3" stroke="#eef0f5" stroke-width="4.25"></path><line x1="469.428008" y1="113.361386" x2="569.885602" y2="113.361386" id="Stroke-4" stroke="#eef0f5" stroke-width="4.5"></line><line x1="1" y1="114.361386" x2="101.457594" y2="114.361386" id="Stroke-5" stroke="#eef0f5" stroke-width="4.5"></line><line x1="101.5" y1="161.5" x2="100.927022" y2="0" id="Stroke-6" stroke="#eef0f5" stroke-width="4.5"></line><line x1="469.5" y1="161.5" x2="469.836292" y2="2" id="Stroke-7" stroke="#eef0f5" stroke-width="4.5"></line><line x1="368.031558" y1="114.272277" x2="469.428008" y2="114.272277" id="Stroke-8" stroke="#eef0f5" stroke-width="4.5"></line><line x1="100.457594" y1="114.272277" x2="202.792899" y2="114.272277" id="Stroke-9" stroke="#eef0f5" stroke-width="4.5"></line><line x1="202.5" y1="371.5" x2="201.529767" y2="2.06501483e-14" id="Stroke-10" stroke="#eef0f5" stroke-width="4.5"></line><line x1="370.5" y1="371.5" x2="368.970414" y2="0" id="Stroke-11" stroke="#eef0f5" stroke-width="4.5"></line><line x1="201.854043" y1="206.945545" x2="370.848126" y2="206.945545" id="Stroke-12" stroke="#eef0f5" stroke-width="4.5"></line></g><g id="text" transform="translate(50.820513, 31.561881)" fill="#000000" fill-rule="nonzero" font-family="PingFangTC-Light, PingFang TC" font-weight="300"><text id="LEFT_BASELINE_3_PTS_AM" position="LEFT_BASELINE_3_PTS" font-size="16"><tspan x="0" y="50">left_baseline_3_pts_a_m</tspan></text><text id="LEFT_BASELINE_3_PTS_PER" position="LEFT_BASELINE_3_PTS" font-size="20"><tspan x="0" y="25">left_baseline_3_pts_percent</tspan></text><text id="LEFT_WING_3_PTS_AM" position="LEFT_WING_3_PTS" font-size="16"><tspan x="40" y="265">left_wing_3_pts_a_m</tspan></text><text id="LEFT_WING_3_PTS_PER" position="LEFT_WING_3_PTS" font-size="20"><tspan x="40" y="240">left_wing_3_pts_percent</tspan></text><text id="LEFT_BASELINE_2_PTS_AM" position="LEFT_BASELINE_2_PTS" font-size="16"><tspan x="100" y="50">left_baseline_2_pts_a_m</tspan></text><text id="LEFT_BASELINE_2_PTS_PER" position="LEFT_BASELINE_2_PTS" font-size="20"><tspan x="100" y="25">left_baseline_2_pts_percent</tspan></text><text id="LEFT_WING_2_PTS_AM" position="LEFT_WING_2_PTS" font-size="16"><tspan x="105" y="160">left_wing_2_pts_a_m</tspan></text><text id="LEFT_WING_2_PTS_PER" position="LEFT_WING_2_PTS" font-size="20"><tspan x="105" y="135">left_wing_2_pts_percent</tspan></text><text id="PAINT_AM" position="PAINT" font-size="16"><tspan x="235" y="95">paint_a_m</tspan></text><text id="PAINT_PER" position="PAINT" font-size="20"><tspan x="235" y="70">paint_percent</tspan></text><text id="TOP_OF_THE_ARC_2_PTS_AM" position="TOP_OF_THE_ARC_2_PTS" font-size="16"><tspan x="235" y="240">top_of_the_arc_2_pts_a_m</tspan></text><text id="TOP_OF_THE_ARC_2_PTS_PER" position="TOP_OF_THE_ARC_2_PTS" font-size="20"><tspan x="235" y="215">top_of_the_arc_2_pts_percent</tspan></text><text id="TOP_OF_THE_ARC_3_PTS_AM" position="TOP_OF_THE_ARC_3_PTS" font-size="16"><tspan x="235" y="320">top_of_the_arc_3_pts_a_m</tspan></text><text id="TOP_OF_THE_ARC_3_PTS_PER" position="TOP_OF_THE_ARC_3_PTS" font-size="20"><tspan x="235" y="295">top_of_the_arc_3_pts_percent</tspan></text><text id="RIGHT_BASELINE_2_PTS_AM" position="RIGHT_BASELINE_2_PTS" font-size="16"><tspan x="370" y="50">right_baseline_2_pts_a_m</tspan></text><text id="RIGHT_BASELINE_2_PTS_PER" position="RIGHT_BASELINE_2_PTS" font-size="20"><tspan x="370" y="25">right_baseline_2_pts_percent</tspan></text><text id="RIGHT_WING_2_PTS_AM" position="RIGHT_WING_2_PTS" font-size="16"><tspan x="365" y="160">right_wing_2_pts_a_m</tspan></text><text id="RIGHT_WING_2_PTS_PER" position="RIGHT_WING_2_PTS" font-size="20"><tspan x="365" y="135">right_wing_2_pts_percent</tspan></text><text id="RIGHT_BASELINE_3_PTS_AM" position="RIGHT_BASELINE_3_PTS" font-size="16"><tspan x="470" y="50">right_baseline_3_pts_a_m</tspan></text><text id="RIGHT_BASELINE_3_PTS_PER" position="RIGHT_BASELINE_3_PTS" font-size="20"><tspan x="470" y="25">right_baseline_3_pts_percent</tspan></text><text id="RIGHT_WING_3_PTS_AM" position="RIGHT_WING_3_PTS" font-size="16"><tspan x="430" y="265">right_wing_3_pts_a_m</tspan></text><text id="RIGHT_WING_3_PTS_PER" position="RIGHT_WING_3_PTS" font-size="20"><tspan x="430" y="240">right_wing_3_pts_percent</tspan></text></g></g></svg>',
      positionNameList: [
        "PAINT",
        "TOP_OF_THE_ARC_2_PTS",
        "TOP_OF_THE_ARC_3_PTS",
        "LEFT_BASELINE_2_PTS",
        "RIGHT_BASELINE_2_PTS",
        "LEFT_BASELINE_3_PTS",
        "RIGHT_BASELINE_3_PTS",
        "LEFT_WING_2_PTS",
        "RIGHT_WING_2_PTS",
        "LEFT_WING_3_PTS",
        "RIGHT_WING_3_PTS",
      ],
    };
  },
  methods: {
    setScore() {
      let svgHtml = this.svgCode;
      for (let position of this.positionList) {
        let a_m_name = position.name.toLowerCase() + "_a_m";
        let percent_name = position.name.toLowerCase() + "_percent";
        svgHtml = svgHtml.replace(a_m_name, position.fgm + "/" + position.fga);
        svgHtml = svgHtml.replace(percent_name, position.fg_pct);

        if (position.name.includes("3_PTS")) {
          this.blockColor[position.name] = this.getThreePtsColor(
            position.fg_pct
          );
        } else {
          this.blockColor[position.name] = this.getTwoPtColor(position.fg_pct);
        }
      }
      this.$refs.positionfield.innerHTML = svgHtml;
    },
    getTwoPtColor(fg_pct) {
      if (fg_pct < 30) {
        return this.colorWhite;
      } else if (fg_pct >= 30 && fg_pct < 50) {
        return this.subColor;
      } else {
        return this.mainColor;
      }
    },
    getThreePtsColor(fg_pct) {
      if (fg_pct < 20) {
        return this.colorWhite;
      } else if (fg_pct >= 20 && fg_pct < 33) {
        return this.subColor;
      } else {
        return this.mainColor;
      }
    },
    addEventListener() {
      let parent = this.$refs.positionfield.children.item(0).children.item(0);
      let childrenRect = parent.getElementsByTagName("rect");
      let childrenPath = parent.getElementsByTagName("path");
      let childrenText = parent.getElementsByTagName("text");
      for (const block of childrenRect) {
        let position = block.getAttribute("position");
        if (this.positionNameList.includes(position)) {
          block.style.fill = this.blockColor[position];
          this.positionClickEvent(block);
        }
      }
      for (const block of childrenPath) {
        let position = block.getAttribute("position");
        if (this.positionNameList.includes(position)) {
          block.style.fill = this.blockColor[position];
          this.positionClickEvent(block);
        }
      }
      for (const text of childrenText) {
        let position = text.getAttribute("position");
        if (this.positionNameList.includes(position)) {
          this.positionClickEvent(text);
        }
      }
    },
    positionClickEvent(element) {
      const position = element.getAttribute("position");
      element.addEventListener("click", () => {
        this.$emit("positionClick", position);
      });
    },
  },
};
</script>

<style lang="scss">
.position_field {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.position_field_svg_wrapper {
  max-width: 700px;
  width: 100%;
}
svg.position_field_svg {
  width: 100%;
  height: 100%;
}
g#position_field_svg {
  cursor: pointer;
  g#position {
    rect,
    path {
      &:hover {
        filter: brightness(1.2);
      }
    }
  }
  text {
    text-anchor: middle;
  }
}
#positionField,
#wrapper,
#stroke_wrapper {
  stroke-width: 5;
  stroke: #e6ecf1;
}

.labels {
  display: inline-block;
  width: 100%;

  * {
    display: inline-block;
  }

  p {
    margin-right: 20px;
    margin-bottom: 0;
    display: inline-block;
    font-size: 13px;
    font-weight: 500;
  }
}

.mark_group {
  display: inline-block;

  .mark {
    display: inline-block;
    margin-right: 15px;

    .rect {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-radius: 2px;
    }

    span {
      margin-left: 5px;
      font-size: 13px;
      font-weight: 500;
      color: $deepGray;
    }
  }
}
</style>
